import { ArrowUpRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import AssetsPreview from "./AssetsPreview";
const HeroSection = () => {
  return <section className="relative min-h-screen flex items-center justify-center pt-24 md:pt-48 pb-8 overflow-hidden sm:pb-[10px]">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10 max-w-full" style={{ minHeight: '400px' }}>
        <div className="max-w-4xl mx-auto text-center" style={{ minHeight: '180px' }}>
          {/* Headline */}
          <h1 style={{
          animationDelay: "0.1s"
        }} className="text-2xl sm:text-3xl md:text-4xl font-light tracking-[-0.02em] leading-[1.15] mb-6 animate-fade-up text-foreground font-mono">
            Real Estate, rebuilt for the future
          </h1>

          {/* Paragraph 1 */}
          <p style={{
          animationDelay: "0.2s"
        }} className="text-sm text-foreground/70 max-w-2xl mx-auto mb-3 leading-relaxed font-light animate-fade-up font-mono">
            AurØra provides secure, on-chain access to income generated by professionally managed property in the United Kingdom.
          </p>

          {/* Paragraph 2 */}
          <p style={{
          animationDelay: "0.25s"
        }} className="text-sm text-foreground/70 max-w-2xl mx-auto mb-10 leading-relaxed font-light animate-fade-up font-mono">
            Structured income rights are delivered through a single platform, combining transparency, discipline, and institutional-grade asset management.
          </p>

          {/* CTA Button */}
          <div className="animate-fade-up" style={{
          animationDelay: "0.35s"
        }}>
            <a href="#waitlist" className="inline-block glow-radial-strong">
              <Button variant="hero" size="lg" className="rounded-full px-8 font-medium">
                Get Early Access
                <ArrowUpRight className="ml-2 w-4 h-4" />
              </Button>
            </a>
          </div>
        </div>

        {/* Assets Preview */}
        <div className="animate-fade-up mt-16" style={{
        animationDelay: "0.4s"
      }}>
          <AssetsPreview />
        </div>
      </div>
    </section>;
};
export default HeroSection;